import toonShade from "../snippets/toonShade";

export default `
precision highp float;

varying vec2 vUv;
varying mat3 vNormalMatrix;
varying vec3 vWorldPosition;

uniform sampler2D texture;
uniform sampler2D heightmap;
uniform sampler2D normalMap;
uniform sampler2D inflatedNormalMap;

uniform vec4 tint;
uniform float antigenIntensity;
uniform vec3 antigenColor;
uniform float inflation;

uniform vec2 lightPos;

uniform bool isTransparentShell;
uniform vec3 backgroundColor;


void main() {
	vec4 color = texture2D(texture, vUv);

	if(isTransparentShell) {
		vec3 membraneColor = mix(backgroundColor, vec3(1., 1., 1.), 0.2);
		color = vec4(membraneColor, color.a);
	}

	vec4 heightVal = texture2D(heightmap, vUv);
	float antigen = heightVal.y;

	//Get light posiition
	vec3 lightPosition = vec3(lightPos, 1000); //need a z-dimension for the lighting in "pixels"
	vec3 lightDirection = normalize(lightPosition - vWorldPosition);

	vec4 normalMapValue = texture2D(normalMap, vUv);
	vec3 normal = normalize(normalMapValue.xyz * 2.0 - 1.0);
	normal = normalize(vNormalMatrix * normal);

	//Apply inflation effect by blending with a blown up looking normal map
	vec4 inflatedNormalMapValue = texture2D(inflatedNormalMap, vUv);
	vec3 inflated = normalize(inflatedNormalMapValue.xyz * 2.0 - 1.0);
	inflated = normalize(vNormalMatrix * inflated);
	normal = mix(normal, inflated, inflation);

	//Ambient lighting
	float ambientScaler = 0.40; //TODO: There is def something wrong with these balances/way this works.
	vec3 ambientColor = vec3( ambientScaler ); //TODO: Pass this in

	//Diffuse lighting
	float diffuseLight = max(dot(normal, lightDirection), 0.0);
	float diffuseScaler = 0.75;
	vec3 diffuseColor = vec3( vec3(diffuseScaler) * diffuseLight);

	//Specular lighting
	float specularScaler = 0.5;
	float shininess = antigen > 0.0 ? 128.0 : 16.0;
	vec3 cameraPos = vec3(vWorldPosition.x, vWorldPosition.y, -10.0);
	vec3 viewDir = normalize(cameraPos - vWorldPosition);
	//Confusuin here, sources say you are supposed to invert vLightDir, but I get wrong result if I do..
	vec3 reflectDir = reflect(lightDirection, normal);
	float spec = pow(max(dot(viewDir, reflectDir), 0.0), shininess);
	vec3 specularColor = specularScaler * spec * color.xyz;  

	//Do antigen glowing
	float antigenScaler = antigenIntensity * antigen;

	//Regular Phong lighting
	vec3 litColor = (color.xyz * (diffuseColor + ambientColor + specularColor + antigenScaler));
	vec3 result = litColor.xyz;

	//Tests
	//result = normal.xyz; 
	//result = color.xyz; 

	//Toon shading
	vec3 toonColor = result.xyz;
	//vec3 result;
	${toonShade('toonColor', 'diffuseLight', 'spec', 'result')}

	float alpha = color.a;
	if(isTransparentShell) {
		float litness = abs((diffuseLight + spec) - 0.5) * 2.0;
		float membraneAlpha = 0.1; //min(1.0, heightVal.z / 2.0);
		alpha = mix(1.0, membraneAlpha, 1.0 - litness);
		alpha = pow(alpha, 2.0); //idk looks a bit cooler
	}
	vec4 final = vec4(result, alpha);

	//Apply tint
	final = mix(final, tint, tint.a);
	if(color.a == 0.0) final.a = 0.0;

	gl_FragColor = final;

	//Debug normal
	//gl_FragColor = normalMapValue;
}
`
